import { apiSlice } from '../../../../app/apiSlice';
import { formatDateToISO } from '../../../../utils/formatDate';

import configSiteUrls from '../../configs/configSiteUrls';
import { PublicacaoOficialListPublicResponse } from './types/PublicacaoOficial';

import { PublicacaoOficialAnexo } from './types/PublicacaoOficialAnexo';
import { PublicacaoOficialVereadorList } from './types/PublicacaoOficialVereador';
//usei o publicacaoOficial como base

const endpointUrl = configSiteUrls.SITE_PUBLICACAO_OFICIAL_EP;
const endpointUrlPublic = configSiteUrls.SITE_PUBLICACAO_OFICIAL_PUBLIC_EP;

interface Params {
  data_inicial?: string | null;
  data_final?: string | null;
  search?: string | null;
  page?: number;
  apply?: boolean;
  exercicio?: string | null;
  tipo?: string | null;
}

function getPublicacoesOficiaisPublic({ data_inicial, data_final, search, page = 1, exercicio, tipo }: Params) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.set('search', search);
  if (data_inicial) queryParams.set('dataInicial', formatDateToISO(data_inicial));
  if (data_final) queryParams.set('dataFinal', formatDateToISO(data_final));
  queryParams.set('page', page.toString());
  if (exercicio) queryParams.set('exercicio', exercicio);
  if (tipo) queryParams.set('tipo', tipo);

  return {
    url: `${endpointUrlPublic}/all?${queryParams.toString()}`,
    method: 'GET'
  };
}

function getPublicacaoOficialAnexos({ idPublicacaoOficial }: { idPublicacaoOficial: string }) {
  if (!idPublicacaoOficial) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrl}/anexos?idn=${idPublicacaoOficial}`,
    method: 'GET'
  };
}

function getPublicacaoOficialAnexosPublic({ idPublicacaoOficial }: { idPublicacaoOficial: string }) {
  if (!idPublicacaoOficial) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idPublicacaoOficial}`,
    method: 'GET'
  };
}

function getPublicacaoOficialVereadores({ idPublicacaoOficial }: { idPublicacaoOficial: string }) {
  if (!idPublicacaoOficial) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrl}/vereadores?idn=${idPublicacaoOficial}`,
    method: 'GET'
  };
}

function addAnexos(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function addVereadores(formData: FormData) {
  return {
    url: `${endpointUrl}/vereadores/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function addCapa(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/capa`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function removeAnexosExcluidos(formData: FormData) {
  return {
    url: `${endpointUrl}/remover-anexos`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function getUltimasPublicacoesPublic() {
  return {
    url: `${endpointUrlPublic}/last`, // remove /all se não existir no backend
    method: 'GET'
  };
}

export const publicacaoOficialAnexoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getPublicacaoOficialAnexos: query<PublicacaoOficialAnexo[], { idPublicacaoOficial: string }>({
      query: getPublicacaoOficialAnexos,
      providesTags: ['PublicacaoOficialAnexoSite']
    }),
    getPublicacaoOficialAnexosPublic: query<PublicacaoOficialAnexo[], { idPublicacaoOficial: string }>({
      query: getPublicacaoOficialAnexosPublic,
      providesTags: ['PublicacaoOficialAnexoSite']
    }),
    getPublicacaoOficialVereadores: query<PublicacaoOficialVereadorList[], { idPublicacaoOficial: string }>({
      query: getPublicacaoOficialVereadores,
      providesTags: ['PublicacaoOficialAnexoSite']
    }),

    getPublicacoesOficiaisPublic: query<PublicacaoOficialListPublicResponse, Params>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getPublicacoesOficiaisPublic,
      providesTags: ['PublicacaoOficialAnexoSite']
    }),
    getUltimasPublicacoesPublic: query<PublicacaoOficialListPublicResponse, void>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getUltimasPublicacoesPublic,
      providesTags: ['NoticiaSite']
    }),

    addPublicacaoOficialAnexos: mutation<void, FormData>({
      query: addAnexos,
      invalidatesTags: ['PublicacaoOficialAnexoSite']
    }),
    addPublicacaoOficialVereadores: mutation<void, FormData>({
      query: addVereadores,
      invalidatesTags: ['PublicacaoOficialAnexoSite']
    }),
    addPublicacaoOficialCapa: mutation<void, FormData>({
      query: addCapa,
      invalidatesTags: ['PublicacaoOficialAnexoSite']
    }),
    removePublicacaoOficialAnexoExcluido: mutation<void, FormData>({
      query: removeAnexosExcluidos,
      invalidatesTags: ['PublicacaoOficialAnexoSite']
    })
  })
});
export const {
  useGetPublicacaoOficialAnexosQuery,
  useAddPublicacaoOficialAnexosMutation,
  useAddPublicacaoOficialVereadoresMutation,
  useRemovePublicacaoOficialAnexoExcluidoMutation,
  useGetPublicacaoOficialVereadoresQuery,
  //useGetPublicacaoOficialAnexoDownloadQuery,
  useLazyGetPublicacaoOficialAnexosQuery,
  useGetPublicacaoOficialAnexosPublicQuery,
  useLazyGetPublicacaoOficialAnexosPublicQuery,
  useGetPublicacoesOficiaisPublicQuery,
  useLazyGetPublicacoesOficiaisPublicQuery,
  useGetUltimasPublicacoesPublicQuery
} = publicacaoOficialAnexoApiSlice;
